import { SubtoolVertex } from '@editor/interfaces/tool'
import { createSlice } from '@reduxjs/toolkit'

export interface ToolUtilsVertexState {
  /**
   * List of available vertex subtools
   */
  availableVertexSubtools: SubtoolVertex[]

  /**
   * Current selected vertex subtool
   */
  currentVertexSubtool: SubtoolVertex

  /**
   * Whether vertex subtools are disabled
   */
  disableVertexSubtools: boolean

  /**
   * Whether to disable switching vertex subtools
   */
  disableSwitchingVertexSubtool: boolean
}

export const initialVertexState: ToolUtilsVertexState = {
  availableVertexSubtools: [],
  currentVertexSubtool: SubtoolVertex.None,
  disableVertexSubtools: false,
  disableSwitchingVertexSubtool: false,
}

export const slice = createSlice({
  name: 'toolUtil/vertex',
  initialState: initialVertexState,
  reducers: {
    setAvailableVertexSubtools(state, action: { payload: SubtoolVertex[] }) {
      state.availableVertexSubtools = action.payload

      if (state.availableVertexSubtools.length) {
        ;[state.currentVertexSubtool] = state.availableVertexSubtools
      } else {
        state.currentVertexSubtool = SubtoolVertex.None
      }
    },
    setCurrentVertexSubtool(state, action: { payload: SubtoolVertex }) {
      state.currentVertexSubtool = action.payload
    },
    setDisableVertexSubtools(state, action: { payload: boolean }) {
      state.disableVertexSubtools = action.payload
    },
    setDisableSwitchingVertexSubtool(state, action: { payload: boolean }) {
      state.disableSwitchingVertexSubtool = action.payload
    },
  },
})

export default slice.reducer
export const {
  setAvailableVertexSubtools,
  setCurrentVertexSubtool,
  setDisableVertexSubtools,
  setDisableSwitchingVertexSubtool,
} = slice.actions
